module.exports = __webpack_public_path__ + "img/0-62.da8e4b90.jpg";